module.exports = __webpack_public_path__ + "img/icon_withdraw.275ba994.png";